/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-danger */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import DOMPurify from 'dompurify';
import FlyoutModal from '../common/FlyoutModal';
import Modal from '../common/Modal/Modal';
import messages from './messages';
import styles from './AttributeModal.module.scss';
import { FLYOUT_MODAL_THEME_GUIDE } from '../common/FlyoutModal/constants';

const AttributeModal = ({
  title, content, backButtonLabel = null, type = 'default',
}) => {
  const { sanitize } = DOMPurify;
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(
    (e) => {
      if (e) {
        e.preventDefault();
      }
      setIsOpen((prevState) => !prevState);
    },
    [setIsOpen],
  );

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      toggle();
    }
  };

  return (
    <>
      {isOpen &&
        (type === 'default' ? (
          <Modal isVisible onClose={toggle}>
            <div className={styles.modalContent}>
              <div dangerouslySetInnerHTML={{ __html: sanitize(content) }} />
              <button
                type="button"
                className={styles.closeBtn}
                onClick={toggle}
              />
            </div>
          </Modal>
        ) : (
          <FlyoutModal
            title={title}
            isVisible
            onCloseModal={() => setIsOpen(false)}
            backButtonLabel={
              backButtonLabel ?? formatMessage(messages.backLabel)
            }
            theme={FLYOUT_MODAL_THEME_GUIDE}
          >
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{
                __html: sanitize(content),
              }}
            />
          </FlyoutModal>
        ))}
      <div
        className={styles.title}
        onClick={toggle}
        onKeyDown={onKeyDown}
        role="button"
        tabIndex={0}
      >
        {title}
      </div>
    </>
  );
};

AttributeModal.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  backButtonLabel: PropTypes.string,
  type: PropTypes.oneOf(['default', 'flyout']),
};

export default AttributeModal;
